/**
 * Sets CSS vars for dominant color based on package icon dominant color
 */

import { fallbackColor } from '../constants';

// https://www.nbdtech.com/Blog/archive/2008/04/27/calculating-the-perceived-brightness-of-a-color.aspx
export function isColorDark(color: string) {
  const hexToRgb = (hex: string) => ({
    r: parseInt(`0x${hex[1]}${hex[2]}`, 16) || 0,
    g: parseInt(`0x${hex[3]}${hex[4]}`, 16) || 0,
    b: parseInt(`0x${hex[5]}${hex[6]}`, 16) || 0,
  });

  const colorAsRgb = hexToRgb(color);
  const colorIsDark =
    Math.sqrt(
      0.241 * colorAsRgb.r * colorAsRgb.r +
        0.691 * colorAsRgb.g * colorAsRgb.g +
        0.068 * colorAsRgb.b * colorAsRgb.b
    ) < 130;

  return colorIsDark;
}

export function dominantColorGenerator(
  elm: HTMLElement,
  baseColor?: string,
  defaultColor?: string
): void {
  defaultColor = defaultColor ?? fallbackColor;

  elm.style.setProperty(
    '--dominant-color-header',
    `${baseColor ?? defaultColor}e6`
  );

  elm.style.setProperty('--dominant-color', `${baseColor ?? defaultColor}`);
  elm.style.setProperty(
    '--dominant-color-opaque',
    `${baseColor ?? defaultColor}33`
  );

  const colorIsDark = isColorDark(baseColor ?? defaultColor);

  elm.style.setProperty(
    '--dominant-color-text',
    colorIsDark ? 'var(--grey)' : 'var(--uui-color-text)'
  );
}
